<a class="skip-link" href="#main-content">Skip to Main Content</a>
<ng-container *ngIf="isLogin; else loadingCheck">
  <ptg-layout>
    <router-outlet id="main-content" tabindex="-1"></router-outlet>
  </ptg-layout>
</ng-container>

<ng-template #loadingCheck>
  <div id="loading-check">
    <div class="wrap-item">
      <mat-progress-spinner diameter="50" mode="indeterminate">
      </mat-progress-spinner>
      <p>Loading...</p>
    </div>
  </div>
</ng-template>
